import { render, staticRenderFns } from "./MitMyStoragePage.vue?vue&type=template&id=1dfbe7cb&scoped=true"
import script from "./MitMyStoragePage.vue?vue&type=script&lang=js"
export * from "./MitMyStoragePage.vue?vue&type=script&lang=js"
import style0 from "./MitMyStoragePage.vue?vue&type=style&index=0&id=1dfbe7cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfbe7cb",
  null
  
)

export default component.exports